enum FormName {
  ExclusionForm = 'exclusionForm',
  ExclusionsExportForm = 'exclusionsExportForm',
}

export default FormName;
